import { render, staticRenderFns } from "./AFGEditor.vue?vue&type=template&id=01701c5d&scoped=true"
import script from "./AFGEditor.vue?vue&type=script&lang=js"
export * from "./AFGEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01701c5d",
  null
  
)

export default component.exports